<template>
  <el-card class="box-card">
    <common-el-form
      :model="model"
      :submitData="submitData"
      @success="onSuccess"
      ref="model"
      :showButton="false"
      :inline="true"
      :SubmitButton="true"
      submit-btn-text="查询"
      failTitle="提交失败"
      loadingText="提交中..."
      :submitService="submitService"
    >
      <p class="commonTitle">团队欢乐返查询</p>
      <div style="display: flex; align-items: center">
        <el-form-item :rules="userId" label="代理商ID" prop="userId">
          <el-input v-model="model.userId" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item :rules="time" label="时间" prop="time">
          <el-date-picker
            v-model="model.time"
            type="daterange"
            range-separator="至"
            :clearable="true"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>结果：{{ jieguo }}</el-form-item>
      </div>
    </common-el-form>
  </el-card>
</template>

<script>
import CommonElForm from "components/common/CommonElForm";

import SystemDicService from "service/SystemDicService";
import PosService from "service/PosService";
import { loadMixin, dialogMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "foundermanage",
  props: {
    isReload: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      jieguo: "",
      submitService: SystemDicService.hlfLIst,
      model: {
        userId: "",
        time: "",
      },
      id: "",
      userId: {
        required: true,
        message: "请输入",
      },
      time: {
        required: true,
        message: "请选择",
      },
    };
  },
  mixins: [loadMixin, dialogMixin],
  components: {
    CommonElForm,
  },
  mounted() {},
  watch: {},
  computed: {
    submitData() {
      if (this.model.time == null || this.model.time == "") {
        this.model.time = [];
      }
      const params = {
        userId: this.model.userId,
      };
      if (this.model.time.length) {
        params.startDate = this.model.time[0];
        params.endDate = this.model.time[1];
      }
      return params;
    },
    // ...mapGetters(["userId", "orgDetail"]),
  },
  methods: {
    onSuccess(res) {
      this.jieguo = res.contents;
      this.showSuccess(res.respMsg);
    },
  },
};
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/view/fragment/select/HLFSelect.vue